const ID = 95515422;

declare global {
  interface Window {
    ym: any;
  }
}

const useYM = () => {
  const { ym } = window;

  const trackPageView = () => {
    if (ym) {
      ym('hit', {
        url: window.location.pathname,
        title: document.title,
      });
    }
  };

  const trackOnClick = (title: string) => {
    if (ym) {
      ym(ID, 'reachGoal', title);

      if (process.env.REACT_APP_NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('reachGoal: ', title);
      }
    }
  };

  const init = () => {
    if (ym) {
      ym(ID, 'init', { ecommerce: true, trackHash: true, trackLinks: true, webvisor: true });
    }
  };

  return { trackPageView, trackOnClick, init };
};

export { useYM };
